/**
 * Resolves the entity id for edit forms mounted on `/:entity/:id` routes.
 *
 * The URL param takes precedence so deep links work (content map edit
 * links, page refreshes, shared URLs). Navigation state is kept as a
 * fallback because the legacy list pages still pass the id through
 * `navigate(path, { state })`.
 */
export const resolveEntityId = (
  idParam: string | undefined,
  stateId: unknown
): number | undefined => {
  if (idParam && /^\d+$/.test(idParam)) {
    return Number(idParam);
  }
  return typeof stateId === "number" ? stateId : undefined;
};
